import { useState, useEffect } from 'react';
import Select from "react-select";
import ApiService from '../../Core/Service/ApiService';

const BrandMultiSelect = ({ selected, onChange }) => {
    const [brands, setBrands] = useState([]);

    useEffect(() => {
        ApiService.get('/brands').then(response => {
            setBrands(response.data.brands?.map(brand => ({
                value: brand,
                label: brand
            })) || []);
        });
    }, []);

    return (
        <Select
            isMulti
            options={brands}
            value={brands.filter(b => selected.includes(b.value))}
            onChange={onChange}
        />
    );
};

export default BrandMultiSelect;
